<template>
  <div id="app">
    <Navbar />
    <Sidebar v-if="isLoggedIn" />
    <div :class="{'main-content': isLoggedIn}">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Sidebar from '@/components/Sidebar.vue';
import { eventBus } from '@/eventBus';

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    Sidebar
  },
  data() {
    return {
      isLoggedIn: false
    }
  },
  created() {
    // Initialize auth state
    this.checkLoginStatus();
    
    // Listen for auth events
    eventBus.on('login-success', this.checkLoginStatus);
    eventBus.on('logout-success', this.checkLoginStatus);
    eventBus.on('register-success', this.checkLoginStatus);
  },
  beforeUnmount() {
    // Clean up event listeners
    eventBus.off('login-success', this.checkLoginStatus);
    eventBus.off('logout-success', this.checkLoginStatus);
    eventBus.off('register-success', this.checkLoginStatus);
    if (this.darkModeMediaQuery) {
      this.darkModeMediaQuery.removeEventListener('change', this.darkModeHandler);
    }
    // Cleanup visibility listener
    if (this.darkModeMediaQuery) {
      this.darkModeMediaQuery.removeEventListener('change', this.darkModeHandler);
    }
  },
  methods: {
    checkLoginStatus() {
      this.isLoggedIn = !!localStorage.getItem('token');
    }
  },
  mounted() {
    // Set the document title
    document.title = 'Hobibaca - Baca Buku Online';

    // Dark mode detection
    this.darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.darkModeHandler = e => {
      if (e.matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };
    if (this.darkModeMediaQuery) {
      this.darkModeMediaQuery.addEventListener('change', this.darkModeHandler);
    }
  },
};
</script>

<style>
body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Dark mode styles */
.dark {
  color-scheme: dark;
}

.dark body {
  background-color: #1a1a1a;
  color: #ffffff;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main-content {
  margin-left: 250px; /* Sesuaikan dengan lebar sidebar */
  padding: 20px;
  min-height: calc(100vh - 60px); /* Sesuaikan dengan tinggi navbar */
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0; /* Remove sidebar margin on mobile */
  }
}
</style>
